'use client';

import { useCommerceCartRoot } from '@components/MiniCart/CommerceCartRoot/CommerceCartRootContext';
import { useCommerceQueryClient } from '@lib/commerce/useCommerceQueryClient';
import { QueryClientProvider } from '@tanstack/react-query';
import { PropsWithChildren } from 'react';

type CommerceQueryProviderProps = PropsWithChildren<{
  /** MULTI_CART: cache commerce-core's org and user context with the header's. */
  shareReferenceQueries?: boolean;
}>;

const OwnCommerceQueryProvider = ({
  shareReferenceQueries = false,
  children,
}: CommerceQueryProviderProps) => {
  const queryClient = useCommerceQueryClient(shareReferenceQueries);

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};

/** The layout's root provider brings the one QueryClient when MULTI_CART is on. */
export const CommerceQueryProvider = (props: CommerceQueryProviderProps) =>
  useCommerceCartRoot() ? (
    <>{props.children}</>
  ) : (
    <OwnCommerceQueryProvider {...props} />
  );
